export default "__VITE_ASSET__$2ciZfOz__"